export const initializeVast: {
  bidfloor: number | null,
  w: number | null,
  h: number | null,
  macrosList: string[],
  mobileWeb: number,
  desktop: number,
  inApp: number,
  ctv: number,
  adServerId: number | null,
} = {
  bidfloor: null,
  w: null,
  h: null,
  macrosList: [],
  mobileWeb: 0,
  desktop: 0,
  inApp: 0,
  ctv: 0,
  adServerId: null,
};

export const requiredFieldsForSSPModal = {
  h: 'Height',
  w: 'Width',
  totalSpendLimit: '',
};

export const requiredMacrosForSSPModal = {
  mobile_app: ['[APP_BUNDLE]'],
  ctv: ['[APP_BUNDLE]'],
  mobile_web: ['[PAGE_URL]', '[DOMAIN]'],
  desktop: ['[PAGE_URL]', '[DOMAIN]'],
};

export const sizesListForSSPModal: { id: number, name: string }[] = [
  { id: 0, name: 'All Sizes' },
  { id: 1, name: 'Custom' },
];

export const allowCountriesTriggerForSSPModal = [{ id: 0, name: 'Block' }, { id: 1, name: 'Allow' }];

export const fraudItemsForSSPModal = [{ id: 0, name: 'Clean traffic' }, { id: 1, name: 'Fraud traffic' }];

export const pubWritingItemsForSSPModal = [
  { id: 'enabled', name: 'Enable writing publisher IDs' },
  { id: 'disabled', name: 'Disable writing publisher IDs' },
  { id: 'automated', name: 'Automated' },
];

export const initializeArrayOfMargins: { key: string, minValue: number, maxValue: number }[] = [{ key: 'margin', minValue: 0, maxValue: 100 }];

export const connectionsForSSPModal = {
  rtb: 0,
  vast: 1,
  js: 3,
  prebid: 4,
  prebidJs: 5,
};

export const vastConnectionsForSSPModal = {
  vastToAll: 0,
  vastToVast: 1,
  vastToRtb: 2,
};

export const impTriggeringItems = [
  { id: 'adm', name: 'ADM' },
  { id: 'burlAdm', name: 'ADM+bURL' },
];

export const sizesListForEditSSPModal: { id: string, name: string }[] = [
  { id: '0', name: 'All Sizes' },
  { id: '1', name: 'Custom' },
];